// Sentry must be initialized FIRST, before any other imports
import './lib/sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/fonts.css'; // Local Nunito font
import './index.css';
import './lib/analytics'; // Initialize Mixpanel
import './lib/i18n'; // Initialize i18n
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
